import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Container, Typography, Box } from '@mui/material';
import { privacySections } from '../../content/privacy';

const Privacy = () => {
  return (
    <Container sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }} maxWidth={false} disableGutters>
      <Header />
      <Container component="main" maxWidth="md" sx={{ flex: 1, pt: '80px', pb: 4, px: 3 }}>
        <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
          Privacy Policy
        </Typography>
        {privacySections.map((section, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Typography variant="h6" component="h2" sx={{ mb: 1 }}>
              {section.title}
            </Typography>
            {section.body.map((paragraph, j) => (
              <Typography key={j} variant="body1" paragraph>
                {paragraph}
              </Typography>
            ))}
          </Box>
        ))}
      </Container>
      <Footer />
    </Container>
  );
};

export default Privacy;
